<template>
    <p-modal 
        :name="name" 
        size="sm" 
        no-close-on-esc
        ok-only
        ok-title="Close"
        @show="allowEdit = false"
        label="Accounting Cost">
        <template v-slot:default>
            <div>
                <b-row class="text-center">
                    <b-col>
                        <span><h4>Sku: {{ initialValues.sku }}</h4></span>
                    </b-col>
                </b-row>
                <b-row class="justify-content-center pt-3">
                    <b-col style="max-width: 140px;">
                        <p-number 
                            input-type="money" 
                            :disabled="!allowEdit" 
                            v-model.number="initialValues.accountingCost"
                            ></p-number>
                    </b-col>
                    <b-col v-if="!allowEdit" style="max-width: 145px;">
                        <b-button 
                            variant="primary" 
                            @click="onRecalculate">Recalculate</b-button>
                    </b-col>
                    <b-col v-else  style="max-width: 145px;">
                        <b-button 
                            variant="primary" 
                            @click="onSave">Save Change</b-button>
                    </b-col>
                </b-row>
                <b-row v-if="isAllowedEdit" class="justify-content-center pt-2">                           
                    <b-col style="max-width: 145px;">
                        <b-button variant="outline-primary" @click="allowEdit = !allowEdit">{{ allowEdit ? 'Disable' : 'Enable' }} Edit</b-button>
                    </b-col>                
                </b-row>
                <b-row class="text-center pt-3">
                    <b-col>
                        <span class="text-bold">*The Accounting Cost value is different than the Cost value shown outside this modal.</span>
                    </b-col>
                </b-row>
            </div>
        </template>
    </p-modal>
</template>

<script>
import axios from "axios";
import selectListOptionsDataContext from '@/services/selectListOptions.dataContext.js';

export default {
    emits: ['ok'],
    props: {
        initialValues: {
            type: Object,
            default: () => {
                return {
                    margin: 0,
                    cost: 0,
                    retail: 0,
                    accountingCost: 0
                };
            }
        },
        name: {
            type: String,
            default: 'accountingCostUpdater'
        },
        isPackage: {
            type: Boolean,
            default: false
        },
        parameters: Object
    },
    data() {
        return {
            allowEdit: false
        };
    },
    computed: {
        isAllowedEdit() {
            return !this.isPackage && (this.$currentUserHasRole('Accounting Admin') || this.$currentUserHasRole('Admin'));
        }
    },
    methods: {
        async onRecalculate() {
            var locId = await selectListOptionsDataContext.getSelectedLocationIdAsync();
            this.$bvModal
                .msgBoxConfirm('You will re-calculate the accounting cost of items. Are you sure this is what you want to do?')
                .then(value => {
                    if (value) {
                        axios.post('stockledgers/accountingcalculation', { LocationId: locId, Sku: this.initialValues.sku, executionType: 1 }) // executionType: 1 is apply accounting cost if calculable
                            .then(resp => {
                                const result = resp.data.find(x => x.sku === this.initialValues.sku);
                                if (result.calculatedCost) {
                                    this.$appSuccess(
                                            `The accounting cost has been processed`
                                        )

                                    this.initialValues.accountingCost = result.accountingCost;
                                    this.$emit('ok', this.initialValues);
                                }
                                else {
                                    if(this.isPackage)
                                    {
                                        this.$appError(
                                                `Insufficient data to calculate cost. Please confirm all Package components Accounting Cost can be calculated.`
                                            )
                                    } else
                                    {
                                        this.$appError(
                                                `Insufficient data to calculate cost. Please confirm SOH and/or set Accounting Cost manually.`
                                            )
                                    }
                                }
                            });
                            this.allowEdit = false;
                    }
                })
        },
        async onSave() {
            var locId = await selectListOptionsDataContext.getSelectedLocationIdAsync();
            this.$bvModal
                .msgBoxConfirm('Changing accounting cost alters system-generated actions and may negatively impact accounting ledgers. Are you sure you want to continue?')
                .then(value => {
                    if (value) {
                        axios.post('stockledgers/updateaccountingcost', { LocationId: locId, Sku: this.initialValues.sku, UpdateAccountingCost: this.initialValues.accountingCost })
                            .then(resp => {
                                if (resp) {
                                    this.$appSuccess(
                                            `The accounting cost has been updated`
                                        )
                                    this.$emit('ok', this.initialValues);
                                }
                            });
                        this.allowEdit = false;
                    }
                })
        }
    }
};
</script>
